import React from 'react'
import PropTypes from 'prop-types'
import { Icon, ProfilePicture } from '../../../../../../components/generic'
import { colors } from '@lmc/common/constants'

export default function ResidentProfileSectionWrapper({
  color,
  icon,
  style,
  title,
  children,
  residentImage,
  customIcon,
}) {
  return (
    <div style={style}>
      <div style={styles.sectionHeaderContainer}>
        {residentImage ? (
          <ProfilePicture
            style={{ marginRight: 10 }}
            url={residentImage}
            type="handover__small"
          />
        ) : (
          <div
            style={{
              ...styles.iconContainer,
              background: color,
            }}
          >
            {customIcon || <Icon name={icon} />}
          </div>
        )}
        <div style={styles.sectionHeader}>{title}</div>
      </div>
      {children}
    </div>
  )
}

const styles = {
  iconContainer: {
    alignItems: 'center',
    background: colors.darkblue,
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: 1,
    height: 40,
    width: 40,
  },
  sectionHeader: {
    alignSelf: 'flex-end',
    borderColor: colors.grey,
    fontSize: 24,
    flex: 1,
    marginLeft: 12,
  },
  sectionHeaderContainer: {
    display: 'flex',
    marginBottom: 20,
  },
}

ResidentProfileSectionWrapper.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
  customIcon: PropTypes.any,
  residentImage: PropTypes.any,
}
